module.exports = __webpack_public_path__ + "static/media/Story view 1.5c565056.png";